// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { BaseMethod } from './BaseMethod';
import { EnumAccessModifier } from '../../../../../com/MetaPattern/MDA/MD/Base/EnumAccessModifier';
import { BEValueObject } from './BEValueObject';
import { MethodParameter } from './MethodParameter';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 值对象方法 实体类
 * 值对象方法
 */
export class ValueObjectMethod extends BaseMethod {
  /** 访问修饰符 : 访问修饰符 */
  private _accessModifier: EnumAccessModifier;

  /** 设置：访问修饰符 */
  public get accessModifier() {
    return this._accessModifier;
  }

  /** 获取：访问修饰符 */
  public set accessModifier(value: EnumAccessModifier) {
    this._accessModifier = value;
  }

  /** 是否是静态 : 是否是静态方法 */
  private _isStatic: boolean;

  /** 设置：是否是静态 */
  public get isStatic() {
    return this._isStatic;
  }

  /** 获取：是否是静态 */
  public set isStatic(value: boolean) {
    this._isStatic = value;
  }

  /** 值对象 的ID */
  private _valueObject_ID: string;

  /** 获取：值对象 的ID */
  public get valueObject_ID() {
    return this._valueObject_ID;
  }

  /** 设置：值对象 的ID */
  public set valueObject_ID(value: string) {
    this._valueObject_ID = value;
  }

  /** 值对象  */
  private _valueObject: BEValueObject;

  /** 获取：值对象  */
  public get valueObject() {
    return this._valueObject;
  }

  /** 设置：值对象  */
  public set valueObject(value: BEValueObject) {
    this._valueObject = value;
    if (value !== null) {
      this.valueObject_ID = value.id;
    } else {
      this.valueObject_ID = '';
    }
  }

  /** 参数 */
  private _parameters: Array<MethodParameter>;

  /** 获取：参数 */
  public get parameters() {
    return this._parameters;
  }

  /** 设置：参数 */
  public set parameters(value: Array<MethodParameter>) {
    this._parameters = value;
  }

  constructor() {
    super();
    this._accessModifier = EnumAccessModifier.Public;
    this._isStatic = false;
    this._valueObject_ID = '';
    this._valueObject = null;
    this._parameters = new Array<MethodParameter>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: ValueObjectMethod, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.accessModifier = element.accessModifier;
      this.isStatic = element.isStatic;
      this.valueObject_ID = element.valueObject_ID;
      if (hasReference && element.valueObject !== null) {
        this.valueObject = element.valueObject;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.accessModifier = json.AccessModifier as EnumAccessModifier;
    this.isStatic = json.IsStatic;
    this.valueObject_ID = json.ValueObject_ID;
    // if (json.ValueObject !== null) {
    //   this.valueObject = BEValueObject.Create(json.ValueObject);
    // }
    if (json.Parameters && json.Parameters.length > 0) {
      json.Parameters.forEach((element: any) => {
        const methodParameter = MethodParameter.Create(element);
        // methodParameter.valueObjectMethod = this;
        this.parameters.push(methodParameter);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.AccessModifier = this.accessModifier;
    json.IsStatic = this.isStatic;
    json.ValueObject_ID = this.valueObject_ID;
    if (this.parameters && this.parameters.length > 0) {
      json.Parameters = [];
      this.parameters.forEach((element) => {
        json.Parameters.push(element.toJson());
      });
    }
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('代码属性', 'accessModifier', '访问修饰符', EnumDataType.Reference, this.accessModifier, true, '访问修饰符', 'EnumAccessModifier', 'PGRowEnumValue');
    context.addRow('代码属性', 'isStatic', '是否是静态', EnumDataType.Bool, this.isStatic, true, '是否是静态方法', '', '');
    return context;
  }

  static Create(json: any): ValueObjectMethod {
    const valueObjectMethod = new ValueObjectMethod();
    valueObjectMethod.Deserialize(json);
    valueObjectMethod.json = json;
    return valueObjectMethod;
  }
}
